import { RootState } from "@/store/store";
import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { parseUTCDateValue } from "@/shared/utils/date.util";

export const usePermission = (): {
  can: (moduleId: number, action: number) => boolean;
  isSuperAdmin: boolean;
  isCompanyAdmin: boolean;
  isLoaded: boolean;
  userId: number | null;
  companyId: number | null;
  email: string | null;
  isTrialUser: boolean | null;
  userExpiry: Date | null;
} => {
  const {
    permissions,
    isSuperAdmin,
    isCompanyAdmin,
    userId,
    companyId,
    email,
    isTrialUser,
    userExpiry,
    isLoaded,
  } = useSelector((state: RootState) => state.permission);

  const safeUserExpiry = useMemo((): Date | null => {
    return typeof userExpiry === "string"
      ? (parseUTCDateValue(userExpiry) ?? null)
      : null;
  }, [userExpiry]);

  const can = useCallback(
    (moduleId: number, action: number): boolean => {
      if (isSuperAdmin) {
        return true;
      }

      const mask = permissions[moduleId] ?? 0;

      return (mask & action) === action;
    },
    [isSuperAdmin, permissions],
  );

  return {
    can,
    isSuperAdmin,
    isCompanyAdmin: isCompanyAdmin ?? false,
    isLoaded,
    userId: userId ?? null,
    companyId: companyId ?? null,
    email: email ?? null,
    isTrialUser: isTrialUser ?? null,
    userExpiry: safeUserExpiry,
  };
};
